

























































































import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { creatMeetingColumns, meetingCategoryMap, meetingGoalMap } from '@/utils/meeting';
import timeRangePick from '@/components/meeting/timeRangePick.vue';
import groupEdit from '@/components/meeting/groupEdit.vue';

import store from '@/store';

@Component({
  components: {
    timeRangePick,
    groupEdit
  }
})
class meetingTable extends Vue {
  @Prop()
  url;

  @Prop()
  meetingProjectList;

  @Prop()
  meetingType;

  @Prop()
  meetingTitle;

  @Prop()
  meetingCommon;

  data: any[] = [];
  creatMeetingColumns: any[] = creatMeetingColumns;
  meetingCategoryMap: object = meetingCategoryMap;
  meetingGoalMap: object = meetingGoalMap;
  meetingDate: any = {};
  showGroupEdit: boolean = false;
  meetingProjectInfo: object = {};
  loading: boolean = false;
  delayConfirmText: string = '暂不排会后，该项目将不参与本次排会，但数据不会删除，再次进入列表仍可以对该项目进行排会，是否确认取消排会?';
  meetingTitleMap: object = {
    1: 'Seed',
    2: 'Venture',
    3: 'Growth'
  };
  typeMap: object = {
    1: 'online',
    2: 'offline'
  };

  @Watch('meetingProjectList', { immediate: true })
  handleChange(data) {
    this.data = data;
    this.meetingDate = this.meetingCommon ? moment.unix(this.meetingCommon.startTime) : this.setDefaultDate();
    // 初始化会议时间9:00
    if (this.data && this.data.length > 0) {
      this.data.forEach(_ => {
        _.startTime = _.startTime
          ? _.startTime
          : this.meetingDate
            .clone()
            .startOf('day')
            .add(9, 'h')
            .unix();
        _.endTime = _.endTime ? _.endTime : 0;
      });
    }
    this.loading = false;
  }

  get meetingName() {
    let date = this.meetingDate.format('YYYYMMDD');
    let category = this.meetingTitleMap[this.meetingTitle];
    let type = this.typeMap[this.meetingType];
    return date + ' ' + category + '项目决策会(' + type + ')';
  }

  sortData() {
    // 暂不排会的放在最后,排会的按照上会时间
    this.loading = true;
    setTimeout(() => {
      this.data.sort((a, b) => {
        let res = a.active - b.active;
        let res2 = a.startTime - b.startTime;
        if (a.active === false && b.active === false) {
          return 0;
        } else if (res > 0) {
          return -1;
        } else if (res < 0) {
          return 1;
        } else {
          return res2 > 0 ? 1 : res2 === 0 ? 0 : -1;
        }
      });
      this.loading = true;
    }, 200);
  }

  // 暂不排会
  delayProject(row) {
    row.active = !row.active;
    this.sortData();

    this.$nextTick(() => {
      this.$forceUpdate();
    });
  }

  openGroupEdit(row) {
    this.meetingProjectInfo = row;
    this.showGroupEdit = true;
  }

  toProjectDetail(row) {
    window.open(window.location.origin + `/project/detail?id=${row.companyId}`);
  }

  // 编辑飞书群后刷新行数据
  // type: cancel-取消 / new-新建飞书群 / old-关联已有飞书群
  hideGroupEdit(type, info) {
    if (type !== 'cancel') {
      this.meetingProjectInfo['isNew'] = type === 'new' ? true : false;
      this.meetingProjectInfo['groupId'] = info.groupId;
      this.meetingProjectInfo['groupName'] = info.name;
      this.meetingProjectInfo['meetingUsers'] = info.meetingUsers;
      this.meetingProjectInfo['startTime'] = info.startTime;
      this.meetingProjectInfo['endTime'] = info.endTime;
      this.meetingProjectInfo['notice'] = info.notice;
    }
    this.showGroupEdit = false;
  }

  meetingTimeChange(time, row) {
    row.startTime = time[0];
    row.endTime = time[1];
    this.sortData();

    this.$nextTick(() => {
      this.$forceUpdate();
    });
  }
  submit() {
    return {
      projects: cloneDeep(this.meetingProjectList.filter(i => i.active === true)),
      startTime: this.meetingDate.unix(),
      meetingName: this.meetingName
    };
  }
  setDefaultDate() {
    // offline: 当天
    // online-Seed: 最近的一个多周五，当天是周五则到下周五
    // online-Venture: 下周一
    // online-Growth: 下周二
    const day = new Date();
    let { meetingType } = this;
    let template = this.meetingTitle;
    // offline
    if (meetingType === 2) {
      return moment(day.setDate(day.getDate()));
    } else if (template === 1) {
      // seed
      if (day.getDay() < 3) {
        day.setDate(day.getDate() + 3 - day.getDay());
      } else {
        day.setDate(day.getDate() + 7 - (day.getDay() - 3));
      }
      return moment(day.getTime());
    } else {
      let offsetDay;
      switch (template) {
      case 2: // venture
        offsetDay = 1;
        break;
      case 3: // growth
        offsetDay = 2;
        break;
      default:
        offsetDay = 1;
      }
      if (day.getDay() === 0) {
        day.setDate(day.getDate() + offsetDay);
      } else {
        day.setDate(day.getDate() + 7 - day.getDay() + offsetDay);
      }
      return moment(day.getTime());
    }
  }
}
export default meetingTable;
